import debounce from "lodash.debounce";

window.TutorGroups = new (function () {
  let wrapper;
  let students = [];
  let selectedStudentIds = [];
  let form;
  this.setSelects = () => {
    wrapper = $(".tutor-groups");
    if (wrapper && wrapper.length) {
      $("#academic_year", wrapper).select2();

      $("#tutor_group_teacher", wrapper).select2({
        allowClear: false,
        placeholder: "Add teacher +",
        ajax: { dataType: "json", url: "/teacher_entities/autocomplete", delay: 250 },
      });
    }
    let wrapperManage = $(".manage-tutor-groups");
    if (wrapperManage && wrapperManage.length) {
      $("#current_year", wrapperManage).select2({
        placeholder: "Please Select",
        minimumResultsForSearch: Infinity,
        width: "165px",
      });
    }
  };
  this.studentBlock = ({ studentId, studentName, isSelected }) =>
    `<div id="${studentId}">
      <span>${studentName}</span>
      ${
        isSelected
          ? '<button type="button" class="btn-icon text-danger btn-tertiary"><i class="bi-x-lg"></i></button>'
          : '<button type="button" class="btn btn-tertiary">Add <i class="bi-plus"></i></button>'
      }
    </div>`;

  this.handleSearchStudents = debounce((e) => {
    const { value: name } = e.target;
    const html = students
      .filter(
        (student) =>
          !selectedStudentIds.includes(student.id) && student.attributes.name.toLowerCase().includes(name.toLowerCase())
      )
      .map((student) => this.studentBlock({ studentId: student.id, studentName: student.attributes.name }))
      .join("");

    $(".available-students .body", wrapper).html(html);
    $(".available-students .body button", wrapper).on("click", this.handleAddStudent);
  }, 500);

  this.loadStudents = (currentYear) => {
    const url = `/student_entities/autocomplete?current_year=${currentYear}`;
    Shared.callApi({ url }).then(({ results: r }) => {
      students = (r && Array.isArray(r) ? r : []).map((d) => ({ id: d.id, attributes: { name: d.text } }));
      this.handleSearchStudents({ target: { value: "" } });
    });
  };

  this.tutorSecondStep = (e) => {
    e.preventDefault();

    const form = document.querySelector(".tutor-groups form");
    if (!form.checkValidity()) return form.reportValidity();
    const step2Wrapper = form.querySelector(".tutor-group-step2");
    const step1Wrapper = form.querySelector(".tutor-group-step1");
    step2Wrapper.classList.remove("t:hidden");
    step1Wrapper.classList.add("t:hidden");

    const currentYear = $("#academic_year").val();
    this.loadStudents(currentYear);
  };

  this.getStudentFromBlock = (e) => {
    const isButtonClick = e.target;
    const parentDiv = isButtonClick ? e.target.closest("div") : e.closest("div");
    const studentId = parentDiv.getAttribute("id");
    const studentName = parentDiv.children[0].textContent;
    return { studentId, studentName };
  };

  this.removeStudent = (e) => {
    const parentDiv = e.target.closest("div");
    return parentDiv.remove();
  };
  this.handleAddStudent = (e) => {
    const { studentId, studentName } = this.getStudentFromBlock(e);
    this.removeStudent(e);
    const selectedStudentBlock = $(".selected-students .body", wrapper);
    const addedStudent = this.studentBlock({ studentId, studentName, isSelected: true });
    selectedStudentIds.push(studentId);
    selectedStudentBlock.append(addedStudent);
    $("button", selectedStudentBlock).off("click").on("click", this.handleRemoveStudent);
  };

  this.handleRemoveStudent = (e) => {
    const { studentId, studentName } = this.getStudentFromBlock(e);
    this.removeStudent(e);
    const availableStudentBlock = $(".available-students .body", wrapper);
    const deletedStudent = this.studentBlock({ studentId, studentName });
    selectedStudentIds = selectedStudentIds.filter((id) => id != studentId);
    availableStudentBlock.append(deletedStudent);
    $("button", availableStudentBlock).off("click").on("click", this.handleAddStudent);
  };

  this.saveTutorGroup = (e) => {
    const form = e.target;
    // add all selected student to form
    selectedStudentIds.forEach((studentId) =>
      $(form).append(`<input name='tutor_group[student_ids][]' type='hidden' value=${studentId} />`)
    );
    // prevent academic_year field to send
    $(form).find("#academic_year").attr("disabled", "disabled");
    return true;
  };

  this.loadSelectedStudents = () => {
    document.querySelectorAll(".selected-students .body button").forEach((student) => {
      $(student).on("click", this.handleRemoveStudent);
      selectedStudentIds.push(this.getStudentFromBlock(student).studentId);
    });
  };

  this.initForm = () => {
    wrapper = $(".tutor-groups");
    if (!wrapper || !wrapper.length) return;

    $("#btn-continue").on("click", this.tutorSecondStep);
    form = $("form", wrapper);
    form.on("submit", this.saveTutorGroup);

    $("#input-search", form).on("keyup", this.handleSearchStudents);
    $("#tutor_group_name", form).on("change", () => {
      $("#group-name-label").text($("#tutor_group_name").val());
    });
    $("#academic_year", form).on("change", () => {
      $("#year-group-label").text(ordinal(+$("#academic_year").val()) + " year");
    });

    // fix select2 to keep placeholder text after selection
    $("#tutor_group_teacher", form).on("select2:closing", function () {
      $(".select2-search__field", form).attr("placeholder", "Add teacher +");
    });
    this.loadSelectedStudents();
  };
})();
